import { render, staticRenderFns } from "./Omikuji.vue?vue&type=template&id=c712bf64&scoped=true&"
import script from "./Omikuji.vue?vue&type=script&lang=js&"
export * from "./Omikuji.vue?vue&type=script&lang=js&"
import style0 from "./Omikuji.vue?vue&type=style&index=0&id=c712bf64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c712bf64",
  null
  
)

export default component.exports